import { useEffect } from "react";

export const TujhyatRangleleAstitva = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div className="modal" style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", overflowY: "auto", zIndex: 1050, }}>
                <div className="modal-content" style={{ padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", maxHeight: "95vh", overflowY: "auto", }}>
                    <div className="img-fluid mb-4">
                        <picture><img src="/media/poemsmar/tujhyat-ranglele-majhe-astitva.jpg" alt=" तुझ्यात रंगलेले माझे अस्तित्व | Lone Wolf writes " style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray", }} /></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>तुझ्यात रंगलेले माझे अस्तित्व</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        वाटते,<br />
                        तू चालताना, तुझ्या सावलीसारखेच चालावे<br />
                        तू बोलताना, शब्दांमागील प्रत्येक भावना अनुभवावे<br />
                        तू हसताना, त्या हास्याच्या गोडव्याने मन व्यापून जावे<br />
                        तू बागडताना, जीवनाचे रंग नव्याने पहावे<br />
                        वाटते,<br />
                        कायम तुझाच मी बनून राहावे.<br />
                        <br />
                        वाटते,<br />
                        तुझ्या सुखांमध्ये स्वतःला हरवून आनंदी व्हावे<br />
                        तुझ्या दुःखांना माझ्या ह्रदयात सामावून घ्यावे<br />
                        तुझ्या हसूचे कारण बनून उभे राहावे<br />
                        तुझ्या अश्रूंचे थेंबही मिटवण्याचा प्रयत्न करावे<br />
                        वाटते,<br />
                        कायम तुझाच मी बनून राहावे.<br />
                        <br />
                        वाटते,<br />
                        तुला मिठीत घेऊन जग विसरून जावे<br />
                        तुझ्या चेहऱ्यावर आनंदाचे तेज झळकावे<br />
                        तुला सुखावण्यासाठी प्रत्येक क्षण अर्पण करावे<br />
                        तुझ्यातच माझे अस्तित्व हरवून टाकावे<br />
                        वाटते,<br />
                        कायम तुझाच मी बनून राहावे.<br />
                        <br />
                        वाटते,<br />
                        परत-परत प्रेमात तुझ्या पडावे<br />
                        अथांग प्रेमसागरात मी बुडावे<br />
                        उंचच उंच प्रेमपर्वत चढावे<br />
                        तुझ्यासाठी सर्व जगाशीही लढावे<br />
                        वाटते,<br />
                        कायम तुझाच मी बनून राहावे.<br />
                        <br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
